import angular from "angular";

angular.module('ui-sentinel.devices.deviceTracking', [
    'ui-sentinel.devices',
    'ui-sentinel.maps',
    'ui-sentinel.devices.deviceReportToolItem'
]);
